import React from 'react';
import classnames from 'classnames';

function PaginationButton({
  onClick,
  active,
  label,
  disabled = false,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={classnames('page-link', {
        active,
        disabled,
      })}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

export default PaginationButton;
